// import React, { useEffect, useContext } from 'react';
// import { UserContext } from './userContext';
// import { useNavigate } from 'react-router-dom';
// import { backendUrl } from './config';
// import { CircularProgress, Box, Typography } from '@mui/material';

// const OAuthSuccess = () => {
//   const { updateUser } = useContext(UserContext);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchCurrentUser = async () => {
//       try {
//         const response = await fetch(`${backendUrl}/current-user`, {
//           credentials: 'include',
//         });
//         const data = await response.json();
        
//         if (response.ok && data.user) {
//           updateUser(data.user);
//           navigate('/dashboard');
//         } else {
//           navigate('/signin');
//         }
//       } catch (error) {
//         console.error('OAuth Success error:', error);
//         navigate('/signin');
//       }
//     };

//     fetchCurrentUser();
//   }, [navigate, updateUser]);

//   return (
//     <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 10 }}>
//       <CircularProgress />
//       <Typography variant="h6" sx={{ marginTop: 2 }}>
//         Signing you in...
//       </Typography>
//     </Box>
//   );
// };

// export default OAuthSuccess;



// aftetteh firs working copy
// src/components/OAuthSuccess.jsx
import React, { useEffect, useContext } from 'react';
import { UserContext } from './userContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { backendUrl } from './config';
import { CircularProgress, Box, Typography } from '@mui/material';

const OAuthSuccess = () => {
  const { updateUser } = useContext(UserContext);
  const navigate = useNavigate();
  const location = useLocation(); // CHANGE: import useLocation

  useEffect(() => {
    // CHANGE: detect newUser flag in URL
    const params = new URLSearchParams(location.search);
    const isNew = params.get('newUser') === 'true';

    const fetchCurrentUser = async () => {
      try {
        const response = await fetch(`${backendUrl}/current-user`, {
          credentials: 'include',
        });
        const data = await response.json();

        if (response.ok && data.user) {
          updateUser(data.user);
          // CHANGE: redirect new users to /client, existing to /dashboard
          navigate(isNew ? '/client' : '/dashboard');
        } else {
          navigate('/signup');
        }
      } catch (error) {
        console.error('OAuth Success error:', error);
        navigate('/signup');
      }
    };

    fetchCurrentUser();
  }, [location.search, navigate, updateUser]); // CHANGE: include location.search

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        marginTop: 10
      }}
    >
      <CircularProgress />
      <Typography variant="h6" sx={{ marginTop: 2 }}>
        Signing you in...
      </Typography>
    </Box>
  );
};

export default OAuthSuccess;
